// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2bf94dc0","453":"825386d9"}[chunkId] + ".chunk.js";
};